import { Injectable } from "@angular/core";
import { TokenRepo } from "@app/core/shared/domain/token.repo";

/**
 * Use case to check if the user is logged in.
 */
@Injectable({
  providedIn: "root",
})
export class IsLoggedInUseCase {
  constructor(private tokenRepo: TokenRepo) {}

  execute(): boolean {
    return this.tokenRepo.get() !== null;
  }
}
